$(".button-sconti").on("click", function(e) {
  e.preventDefault();

  $(".backplate").addClass("backplate--open");
  $(".o-popup--sconti").addClass("o-popup--open");
});

$(".backplate,.o-popup__close").on("click", function() {
  $(".o-popup--sconti").removeClass("o-popup--open");
  $(".backplate").removeClass("backplate--open");
});
